import { User } from '../classes/user';

/**
 * Where a user lands after sign-in, and wherever `/dashboard` is hit without a
 * child route. One helper because three call sites need the same answer —
 * login.component, DashboardRedirectGuard and NotAuthenticatedGuard — and a
 * user who signs in, returns with a live session, or types `/dashboard`
 * should not end up somewhere different each time.
 *
 * Order matters: a Content-Manager-ONLY account has no Arrangements nav
 * (main-navigation.component.html) and no business in the arranger surfaces,
 * so it goes to Website. A user who holds Content Manager ALONGSIDE another
 * role is a Picaluna staff member and keeps the normal landing page.
 */
export function landingRoute(user: User | null | undefined): string {
  if (user?.isContentManagerOnly()) {
    return '/dashboard/website';
  }

  const showOverview = user?.isDeveloper() || user?.isOperation() || false;

  return showOverview ? '/dashboard/overview' : '/dashboard/arrangements/list';
}
